import React, { Component } from 'react';
import { area, curveBasis } from 'd3-shape';

import PropTypes from 'prop-types';
import { select } from 'd3-selection';

class Stream extends Component{
    componentDidMount(){
        this.renderStreamGraph();
    }

    componentDidUpdate(){
        this.renderStreamGraph();
    }

    renderStreamGraph = () => {
        const { layer, keys: { x }, xScale, yScale } = this.props;

        // D3 area: defined by two bounding lines that share x values but differ in y-values
        const chartArea = area()
            .x( d => xScale()( d.data[x] ) )
            .y0( d => yScale()( d[0] ) )
            .y1( d =>  yScale()( d[1] ) )
            .curve( curveBasis );

        // draw the stream graph
        select( this.stream )
            .selectAll( 'path' )
            .data( layer() )
            .enter()
            .append( 'path' )
            .attr( 'd', chartArea );
    }

    render(){
        const { styles } = this.props;

        return (
            <g className={styles.stream} ref={el => this.stream = el}></g>
        );
    }
};

Stream.propTypes = {
    data: PropTypes.array.isRequired,
    keys: PropTypes.shape( {
        x: PropTypes.string
    } ),
    layer: PropTypes.func.isRequired,
    styles: PropTypes.object,
    xScale: PropTypes.func.isRequired,
    yScale: PropTypes.func.isRequired,
};

export default Stream;
